import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Link } from 'gatsby';
import { queryHelper, nodeHelper } from 'helpers';
import { Wrapper, Logo, FlagsBanner } from './styles';
import { MegaMenu } from 'components';
import { NavBar } from '../NavBar';
import {Auth} from "aws-amplify";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Flags from '../pages/home/TopBanner/Flags';

export const Header = () => {
  const { logo, navtop } = useStaticQuery(graphql`
    query MyHeaderQuery {
      logo: nodeImage(title: {eq: "layoutTopLogo"}) {
        drupal_id
        title
        relationships {
          field_image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 225
                  placeholder: BLURRED
                  formats: [WEBP]
                )
              }
            }
          }
        }
      }     
      navtop: allMenuLinkContentMenuLinkContent(
        filter: {menu_name: {eq: "navtop"}}
        sort: {weight: ASC}
      ) {
        edges {
          node {
            drupal_id
            menu_name
            title
            description
            weight
            enabled
            drupal_parent_menu_item
            link {
              uri
              options {
                menu_icon {
                  uri
                }
              }
            }
          }
        }
      }
    }
  `);

  const headerItems = nodeHelper.setUpTree(navtop);
  const data = {};
  const indexes = ['cardsDropDown', 'buttonGroup', 'iconGroup'];
  indexes.forEach(index => {
    data[index] = headerItems.filter(item => item.title == index)[0].children;
  });

  return (
    <Wrapper>
      <Link to="/">
        <Logo>
          <GatsbyImage image={getImage(queryHelper.getGatsbyImageData(logo))} alt=""/>
        </Logo>
        <FlagsBanner>
          <Flags/>
        </FlagsBanner>
      </Link>
      <MegaMenu data={data.cardsDropDown} title="Cards" />
      <NavBar
        data={{ buttonGroup: data.buttonGroup, iconGroup: data.iconGroup }}
      />
    </Wrapper>
  );
};
